<template>
  <div class="text-darkBlue">
    <h2 class="text-2xl font-semibold flex items-center">
      <span
        class="cursor-pointer mr-3"
        @click="goback"
        v-if="back">
         <img src="@/assets/images/icons/back-icon.svg" alt="Attach Image"></span>{{ heading }}</h2>
       <p class="text-xs">{{ breadcrumb }}</p>
       <p><slot name="breadcrumb"></slot></p>
  </div>
</template>

<script>
export default {
  props: ["heading", "breadcrumb", "back"],
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
